(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3161],{

/***/ 44707:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories",
      function () {
        return __webpack_require__(51338);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_components_category_CategoryItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54191);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var Categories = function(param) {
    var categories = param.categories;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "page all-categories",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: "All Categories"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "body",
                    children: categories && categories.filter(function(category) {
                        return category.parentCategoryId === 0 && category.includeInTopMenu === true;
                    }).map(function(parent, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "category-section",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                    children: parent.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "category-items-container",
                                    children: categories.filter(function(category) {
                                        return category.parentCategoryId === parent.id && category.includeInTopMenu === true;
                                    }).map(function(item, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "category-item-container",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_category_CategoryItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                category: item
                                            })
                                        }, index);
                                    })
                                })
                            ]
                        }, i);
                    })
                })
            ]
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Categories);


/***/ }),

/***/ 54191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_img_webp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23085);








var CategoryItem = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(CategoryItem, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(CategoryItem);
    function CategoryItem(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, CategoryItem);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            open: false,
            image: ""
        };
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(CategoryItem, [
        {
            key: "onClickHandle",
            value: function onClickHandle(img) {
                this.setState({
                    image: img
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, category = _props.category, isManual = _props.isManual;
                var imgurl = "/assets/images/dummy.png";
                if (category.imageUrl) {
                    // imgurl = category.imageUrl;
                    var imageName = category.imageUrl.split("/").pop();
                    var ext = imageName.split(".")[1];
                    imgurl = "/assets/images/category/".concat(imageName.split(".")[0], ".").concat(ext === "jpg" ? "jpeg" : ext);
                }
                // var webP = null;
                // if (category.imageUrl) {
                // 	var pos = category.imageUrl.lastIndexOf('.');
                // 	webP = category.imageUrl.substr(0, pos < 0 ? category.imageUrl.length : pos) + '.webp';
                // }
                var url = category.urlSlug ? category.urlSlug : category.id;
                var myHref = isManual ? "/".concat(url) : "/category/[categoryid]?categoryid=".concat(url, "}");
                var asVar = isManual ? url : "/category/".concat(url);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: myHref,
                    as: asVar,
                    prefetch: false,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        className: "inner",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "image-container",
                                children: isManual ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "fad fa-layer-group"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_img_webp__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .Ee, {
                                    width: "100px",
                                    height: "100px",
                                    alt: "category",
                                    src: imgurl,
                                    webP: imgurl,
                                    layout: "intrinsic",
                                    blur: "true"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: category.name
                                })
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return CategoryItem;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
/* harmony default export */ __webpack_exports__["Z"] = (CategoryItem);


/***/ }),

/***/ 23085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ Image$1; }
/* harmony export */ });
/* unused harmony exports Context, canUseWebP */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var WebP = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  supportWebP: false
});

var Image = (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function (props) {
  var childProps = _objectSpread({}, props);

  delete childProps.webP;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(WebP.Consumer, null, function (value) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("img", _extends({}, childProps, {
      src: value.supportWebP && props.webP || props.src
    }));
  });
});

var checked; // eslint-disable-line

function canUseWebP() {
  if ("undefined" !== typeof checked) {
    return checked;
  }

  if ("object" !== (typeof document === "undefined" ? "undefined" : _typeof(document))) {
    return false;
  }

  var canvas = document.createElement("canvas");

  if (!canvas.getContext || !canvas.getContext("2d")) {
    return checked = false;
  }

  return checked = canvas.toDataURL("image/webp").indexOf("data:image/webp") === 0;
}

var WebPController = function WebPController(_ref) {
  var accept = _ref.accept,
      children = _ref.children;

  var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("string" === typeof accept && accept.indexOf("image/webp") !== -1),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      supportWebP = _React$useState2[0],
      setSupport = _React$useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!supportWebP && canUseWebP()) {
      setSupport(true);
    }
  }, []);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(WebP.Provider, {
    value: {
      supportWebP: supportWebP
    }
  }, children);
};



var ContextPackage = /*#__PURE__*/Object.freeze({
  Image: Image,
  WebP: WebP,
  WebPController: WebPController
});

var Image$1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function (props) {
  var childProps = _objectSpread({}, props);

  delete childProps.webP;
  delete childProps.useWebP;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("img", _extends({}, childProps, {
    src: props.useWebP && props.webP || props.src
  }));
});
var ImageDefaultProps = {
  useWebP: canUseWebP()
};
Image$1.defaultProps = ImageDefaultProps;

var Context = (/* unused pure expression or super */ null && (ContextPackage));




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,9774,2888,179], function() { return __webpack_exec__(44707); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);